exports.get = function (state) {
  return state.locationsDB.get('geolocations')
}
